/**
 * Route for `admin-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdminApiPage } from "../features/admin-api/AdminApiPage";

export const adminApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/admin-api",
	component: AdminApiPage,
});

export default adminApiRoute;
